import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HttpErrorResponse } from '@angular/common/http';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ModalpopService } from '../modalpop.service';

@Component({
  selector: 'app-slm-dialog-box',
  templateUrl: './slm-dialog-box.component.html',
  styleUrls: ['./slm-dialog-box.component.scss']
})
export class SlmDialogBoxComponent implements OnInit {

  slmQuantityForm: FormGroup;
  submitButton: true;
  editButton: false;
  deleteButton: false;
  submitpayload: any;
  dropdownValues: Array<string | number | Array<any>> = [];
  dialogRef: MatDialogRef<any>;


  constructor(
     private fb: FormBuilder,
     public umsService: UmsService,
    private spinner: NgxSpinnerService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private modalPopupService: ModalpopService,
    
  ) { }

  ngOnInit(): void {
    this.submitButton = true;
    this.editButton = false;
    this.deleteButton = false;
    this.dropdownValues = this.data.selected;
      this.slmQuantityForm = this.fb.group({
        slmIssueDate: new FormControl ((new Date()).toISOString().substring(0,10), [Validators.required]),
        slmQuantity: new FormControl ('', [Validators.required, Validators.pattern('^[0-9]*$')]),
        slmRemark: new FormControl ('', [Validators.required]),
        });
  }

  submitRecord(){

    if(this.slmQuantityForm.controls['slmQuantity'].value === '')
    {
      this.slmQuantityForm.get('slmQuantity').markAsTouched();
      let data = {};
      data['message'] = 'Please enter SLM Quantity';
      data['title'] = 'Alert';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent,data );
      this.dialogRef.afterClosed().subscribe(() => {
      // window.location.reload();
      this.ngOnInit();
     });
    }
    else{
      this.spinner.show();
      this.submitpayload = {}
      this.submitpayload['SlmId'] = 0;
      this.submitpayload['SnNo'] = this.dropdownValues[0];
      this.submitpayload['CoCode'] = this.dropdownValues[1];
      this.submitpayload['StudyCenter'] = this.dropdownValues[2];
      this.submitpayload['EmId'] = this.dropdownValues[3];
      this.submitpayload['Branch'] = this.dropdownValues[4];
      this.submitpayload['Sub'] = this.dropdownValues[5];
      this.submitpayload['Med'] = this.dropdownValues[6];
      this.submitpayload['EntryDate'] = '';
      this.submitpayload['SlmSent'] = this.slmQuantityForm.controls['slmQuantity'].value;
      this.submitpayload['Remarks'] = this.slmQuantityForm.controls['slmRemark'].value;
      this.umsService.addSlmQuantity(this.submitpayload).subscribe((res) => {
        this.spinner.hide();
          let data = {};
                  data['message'] = res.message;
                  data['title'] = 'Information';
                  data['icon'] = 'fas fa-check';
                  this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent,data );
                  this.dialogRef.afterClosed().subscribe(() => {
                    //window.location.reload();
                    this.ngOnInit();
                  });
    
      }, (ERROR: HttpErrorResponse) => {
       this.spinner.hide();
       let data = {};
       data['message'] = ERROR.error.message;
       data['title'] = 'Alert';
       data['icon'] = 'fas fa-close';
       this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent,data );
       this.dialogRef.afterClosed().subscribe(() => {
       // window.location.reload();
       this.ngOnInit();
      });
  
      }
    );
    }
 
  }



  backPage(){
    window.location.reload();

  }
  

}
